import axios from "axios";
import { localStorageItem } from './../../../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../../../auth/core/_consts";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_KE_HOACH = API + "/plan";

export const addPhieuKhaoSat = (data: any) => {
  let url = API_KE_HOACH;
  return axios.post(url, data);
};
export const updatePhieuKhaoSat = (id: string, data: any) => {
  let url = API_KE_HOACH + `/${id}`;
  return axios.put(url, data);
};

export const getKhaoSatById = (id: string) => {
  let url = API_KE_HOACH + `/${id}`;
  return axios(url);
};

export const searchPhieuKhaoSat = (searchData: any) => {
  const url = `${API_KE_HOACH}` + `/search`;
  return axios.post(url, searchData);
};

export const deletePhieuKeHoach = (trackerCode: string, id: string) => {
  const url = `${API_KE_HOACH}` + `/${trackerCode}/${id}`;
  return axios.delete(url);
};

export const getSupportStaffProposals = (slipId: string) => {
  const url = `${API}` + `/support-staff-proposals/by-slip/${slipId}`;
  return axios(url);
};

export const getProfessionalSupportCapabilities = (slipId: string) => {
  const url = `${API}` + `/professional-support-capabilities/by-slip/${slipId}`;
  return axios(url);
};

export const getConfirmationStatuses = (slipId: string) => {
  const url = `${API}` + `/confirmation-statuses/by-slip/${slipId}`;
  return axios(url);
};

export const getTechTransferEquipment = (slipId: string) => {
  const url = `${API}` + `/tech-transfer-equipment/get-by-slip-id/${slipId}`;
  return axios(url);
};

export const getTechTransferInfrastructure = (slipId: string) => {
  const url = `${API}` + `/tech-transfer-infrastructure/get-by-slip-id/${slipId}`;
  return axios(url);
};
